<template>
  <calling-api path="/api/w/masterData" :once="true">
    <md-autocomplete v-model="selectedItem"
                     @md-changed="handleTermChanged"
                     @md-selected="handleItemSelected"
                     @md-opened="handleOpened"
                     :disabled="disabled"
                     :md-options="items">
      <label v-if="label">{{label}}</label>

      <template class = "selection" slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-tooltip md-delay="50">
          {{ item.name }} ({{item.id}}
        </md-tooltip>
        <template v-if="selectType == 'idOnly'">
        <md-highlight-text :md-term="term">{{item.id}}</md-highlight-text>
      </template>
      <template v-else>
        <md-highlight-text :md-term="term">{{ item.name }} ({{item.id}})</md-highlight-text>
      </template>
      </template>

      <template slot="md-autocomplete-empty" slot-scope="{ term }">
        No item matching "{{ term }}", please enter at least 1 letter.
      </template>

    </md-autocomplete>
  </calling-api>
</template>


<style scoped>
  .selection {
    min-width: 1200px;
  }


</style>

<script>
  import { mapGetters } from 'vuex';
  import _ from 'underscore';
  import lazy from 'lazy.js';
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';

  const lazySearch = _.debounce(
    (vueInstance, term) => {
      console.log(`start lazy`);
      vueInstance.items = new Promise((resolve) => {
        if (term.length > 0) {
          const searchTerm = term.toLowerCase();
          const results = lazy(vueInstance.masterDatas)
            .filter((it) => {
              return it.tagId.toLowerCase()
                  .indexOf(searchTerm) > -1
                || it.tagName.toLowerCase()
                  .indexOf(searchTerm) > -1;
            })
            .take(10)
            .value();
          resolve(results);
        } else {
          resolve([]);
        }
      });
    },
    500,
  );
  export default {
    props: {
      label: String,
      group: String,
      value: String,
      selectType: String,
      preparedOptions: Array,
      onItemSelected: Function,
      disabled: Boolean,
    },
    data: () => ({
      selectedItem: '',
      masterDatas: [],
      items: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
      ]),
    },
    watch: {
      value: {
        handler(newValue) {
          this.selectedItem = newValue;
        },
        immediate: true,
      },
      selectedItem(item) {
        // if (item && _.isObject(item)) {
        //   this.selectedItem = item.tagId;
        //   this.$emit('input', item.tagId);
        // }
        // if (!item || item === '') {
        //   this.onItemSelected(null);
        // }

        if (item && _.isObject(item)) {
          if (this.displayType === 'idOnly') {
            this.selectedItem = item.id;
          } else if (this.displayType === 'nameOnly') {
            this.selectedItem = item.name;
          } else {
            this.selectedItem = `${item.name} (${item.id})`;
          }
        //   this.$emit('input', item.tagId);
        }
        if (!item || item === '') {
            const res = {
                id: null, 
                tagName: null, 
                unit: null, 
                weight : null
            }
          this.onItemSelected(res);
        console.log('test');
        }

        
      },
      group: {
        async handler(newVal, oldVal) {
          if (newVal !== oldVal && !!newVal) {
            //this.selectedItem = '';

          const cache = this.getMasterDataAsSelectOptionByGroup(newVal);
         
          if (cache == null)
          {
            //const master = await api.post('/api/w/masterData', { groups: [newVal] });
            const master = await newAPIPost('/api/w/masterData', { groups: [newVal] });
            const filterMasterData = _(master)
        .filter(it => !!it.active)
        .map((it) => {
          const {
            group, tagId, tagName, parentTagId, parentGroup, measureUnit,weight,diffTolerance
          } = it;
          return {
            group,
            tagId,
            tagName,
            parentTagId,
            parentGroup,
            id: tagId,
            name: tagName,
            unit: measureUnit,
            weight,
            diffTolerance,
          };
        });
            this.masterDatas = filterMasterData
          }
          else
          {
            
            this.masterDatas = cache;
          }
            
           
          }
        },
        immediate: true,
      },

      

      


    },
    methods: {
      clear() {
        this.selectedItem = '';
      },
      handleTermChanged(term) {
        if (this.selectedItem && term !== this.selectedItem) {
          this.selectedItem = '';
        }
        lazySearch(this, term);
      },
      handleItemSelected(item) {
        if (this.onItemSelected) {
            const res = {
                id: item.id, 
                tagName: item.name, 
                unit: item.unit, 
                weight : item.weight
            }
          this.onItemSelected(res);
        }
      },
      handleOpened() {
        this.selectedItem = '';
      },
    },
  };
</script>